import useSession from '../models/useSession'

class SessionMonitor {
  private timeoutId?: NodeJS.Timeout
  private unsubscribe?: () => void

  start() {
    if (this.unsubscribe) return

    this.unsubscribe = useSession.subscribe(state => {
      this.scheduleNextExpiry(state.sessions)
    })

    console.log('Starting session monitor')

    this.scheduleNextExpiry(useSession.getState().sessions)
  }

  stop() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = undefined
    }
    if (this.unsubscribe) {
      this.unsubscribe()
      this.unsubscribe = undefined
    }
  }

  private scheduleNextExpiry(sessions: Session[]) {
    const now = Date.now()

    // Find next expiry time
    let nextExpiry = Infinity

    sessions.forEach(s => {
      if (s.rxBytes && s.rxExpireTime && s.rxExpireTime > now) {
        nextExpiry = Math.min(nextExpiry, s.rxExpireTime)
      }
      if (s.txBytes && s.txExpireTime && s.txExpireTime > now) {
        nextExpiry = Math.min(nextExpiry, s.txExpireTime)
      }
    })

    // If we found a future expiry, schedule it
    if (nextExpiry !== Infinity) {
      const delay = nextExpiry - now

      // Cancel any scheduled expiry
      clearTimeout(this.timeoutId)

      this.timeoutId = setTimeout(() => {
        const sessions = [...useSession.getState().sessions]
        const now = Date.now()
        let hasUpdates = false

        sessions.forEach(s => {
          if (s.rxBytes && s.rxExpireTime && s.rxExpireTime <= now) {
            console.log('clear rx metrics', s.id, s.rxBytes, s.rxExpireTime)
            s.rxBytes = 0
            hasUpdates = true
          }
          if (s.txBytes && s.txExpireTime && s.txExpireTime <= now) {
            console.log('clear tx metrics', s.id, s.txBytes, s.txExpireTime)
            s.txBytes = 0
            hasUpdates = true
          }
        })

        if (hasUpdates) {
          useSession.setState({ sessions })
        }
      }, delay)
    }
  }
}

export default new SessionMonitor()
